<template>
	<div class="deliverable-listing social-media" :class="{hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length)}">
		<div>
			<div class="deliverable-header ">

				<HeaderIcon
					:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
					:totalOutletCount="this.outletCount ? this.outletCount : 0"
					:myWeek="myWeek"
					:title="getGroupHeading"
					:groupTypeTitle="getGroupType"
					:campaignId="socialCampaignId"
					:seriesId="socialSeriesId"
					:masterDeliverableId="masterDeliverableId"
					@toggleExpanded="toggleExpanded"
				/>
			</div>
			<div class="deliverable-block">
				<div class="delv-block-resp">
					<div class="d-flex flex-row dbox-wrapper">
						<div class="dbox-left-side dleft-inner-wrap">

							<b-collapse :visible="expanded" :id="'task-listing-collapse-'+Math.random()">
								<div :class="{'dtable':true,'is-social-series': socialSeriesId ? true:false,'is-social-campaign': socialCampaignId ? true:false}">
								<div class="dtr top-row social list-labels">
								<div class="dtd info-heading titles">
									<span>Post Name</span>
								</div>
								<div class="dtd info-heading message-counter">
								</div>
								<div class="dtd info-heading users">
									<span>People</span>
								</div>
								<div class="dtd info-heading publish-date">
									<span>Posting Date</span>
								</div>
								<!--
								<div class="dtd info-heading thumbnail">
									<span>Thumbnail</span>
								</div>
							-->
								<div class="dtd info-heading thumbnail" v-for="lang in listedLanguages">
									<span>Image</span>
								</div>
								<div class="dtd info-heading caption" v-for="lang in listedLanguages">
									<span>Caption</span>
								</div>
								<div class="dtd info-heading languages">
									<span>Languages</span>
								</div>
								<div class="dtd info-heading social-network">
									<span>Platforms</span>
								</div>
								<div class="dtd info-heading publish-status">
									<span>Post Status</span>
								</div>
							</div>


							<div class="dtr listing-row"
								:class="getRowClass(deliverable, index)"
								v-for="(deliverable, index) in deliverablesArray"
								v-if="index!='totalOutlets'"
								:key="'deliverable'+index"
								ref="listing-row"
								:data-deliverable-id="deliverable.id">
								<div class="dtd titles breakpoint__fix" :style="infoColStyle(deliverable)">
									<div
										:class="`deliverable-title edit-d-title`"
										@click="clickDeliverableTitle(deliverable)"
									>
										<span class="title-text">
											<span class="link-icon" v-if="showManuallyUpdatedIcon(deliverable)">
												<i class="fas fa-unlink"></i>
											</span>
											{{ deliverable.title }}&nbsp;
										</span>
										
									</div>


									<div class="mobile-task-expand-button-area">
										<div class="mobile-task-exp-btn">
											<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expanded" />
										</div>
									</div>
									<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable()" @click.stop="deleteDeliverableClick(deliverable)" :class="`delete-bar ${deliverable.id == stripRemoveDeliverableId ? 'hovered' : ''}`" v-click-outside="deleteDeliverableClickOutside(deliverable.id)" :style="getDeliverableSideBarStyle(deliverable)">
										<span><i class="fas fa-trash"></i></span>
									</div>
								</div>
								<!-- Hard code these like projects, the modal is hard coded anyway -->
								<div 
									v-if="!isMobile()" 
									v-for="(field, index) in _.filter(deliverable.customFields, {field_key: 'user'})" :key="''+deliverable.id+field.field_id"
									class="dtd infos">
									<SocialCustomFields :customField="field" :deliverable="deliverable"/>
								</div>
								<div class="dtd infos message-counter">
									<SocialPostMessageCounter :deliverable="deliverable" @clickMessageCounter="clickDeliverableComments(deliverable)" />
								</div>
								<div class="dtd infos users">
									<span></span>
									<DeliverableListUsers :deliverable="deliverable" />
								</div>
								<div class="dtd infos publish-date">
									<span v-if="!deliverable.is_master" v-html="formatDate(deliverable.publish_date)"></span>
									<span v-else>Master Post</span>
								</div>
								<!--
								<div class="dtd infos thumbnail" v-html="getFirstSocialPostThumbnail(deliverable)">
								</div>
								-->
								<div class="dtd infos thumbnail" v-for="lang in listedLanguages" v-html="getImageForLang(deliverable, lang)">
								</div>
								<div class="dtd infos caption" v-for="lang in listedLanguages">
									<div class="char-count" v-html="getCaptionForLang(deliverable, lang, true)"></div>
									<div class="caption-text" v-html="getCaptionForLang(deliverable, lang)"></div>
								</div>
								<div class="dtd infos languages">
									<span class="info-bubbles languages">
									  <span
									  	v-for="(lang,lang_idx) in deliverable.languages"
									    v-b-tooltip.hover.html
									    :title="getLangCodeById(lang)"
									    class="languages initials badge badge-primary"
									    :class="getLangColorClass(lang,deliverable)"
									  >
									    <span class="exclude-outside-click">{{getLangCodeById(lang)}}</span>
									  </span>
									</span>
								</div>
								<div class="dtd infos social-networks">
									<span class="info-bubbles social-networks">
										<span v-for="(net,net_idx) in deliverable.social_networks" 								    :class="'social-networks initials badge badge-primary '+getSocialNetworkTypeById(net)">

										<i :class="'fab fa-'+getSocialNetworkTypeById(net)+' platform-indicator'"></i>
									</span>
									</span>

								</div>


								<div class="dtd infos publish-status" :style="getPublishStatusStyle(deliverable.publish_status)">
									<!--<PublishStatusListLabel :deliverable="deliverable" @clickStatusLabel="clickDeliverableStatus(deliverable)"/>-->
									<SocialStatusLabel :deliverable="deliverable" :isList="true" />
								</div>
							</div>
							</div>
							<div class="dtable bottom-row social">
								<div class="dtr">
								<div class="dtd filtered-text" >
								<span v-html="getSummaryFilterText"></span>

								<button type="button" v-show="socialSeriesId != null || socialCampaignId != null" class="btn btn-theme header-filter-btns social-group-new-post-btn" @click="clickGetAllGrouped">List All</button>


								<button type="button" class="btn btn-theme header-filter-btns social-group-new-post-btn" @click="newPost"><span  v-html="getNewPostButtonText()">New Post</span> <i class="fas text-primary float-right fa-plus fa-fw"></i></button>
								</div>
							</div>
							</div>
							</b-collapse>


						</div>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditSocialModal from "./EditSocialModal";
import CollapseTaskBtn from "./CollapseTaskBtn";
import SocialCustomFields from '../common/SocialCustomField';
import HeaderIcon from './HeaderIconSocialGrouped';
import toast from '../../toast';
import DeliverableListUsers from "./DeliverableListUsers";
import PublishStatusListLabel from "./PublishStatusListLabel";
import SocialStatusLabel from "./SocialStatusLabel";
import SocialPostMessageCounter from "./SocialPostMessageCounter";

export default {
	props: ["selectedDeliverable", "myWeek", "filterQuery", "expandAll", "calendarOnly", "socialSeriesId", "socialCampaignId", "hasSocialSeries", "hasSocialCampaign", "socialSeriesName", "socialCampaignName", "masterDeliverableId", "listCount", "totalCount"],
	data() {
		return {
			activeView: -1,			
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',
			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,
			expanded:true,
			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,
			currentYear:null,
			currentMonth:null,
			currentDay:null,
			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,
			captionMaxLength: 140,
		}
	},
	components: {
		EditSocialModal,
		CollapseTaskBtn,
		SocialCustomFields,
		HeaderIcon,
		DeliverableListUsers,
		PublishStatusListLabel,
		SocialStatusLabel,
		SocialPostMessageCounter
	},
	computed: {
		...mapGetters([
			"allDeliverables",
			"listSocialCampaigns",
			"listSocialSeries",
			"socialSeries",
			"socialCampaigns",
			"allDeliverablesPaginationData",
			"userDeliverablesPaginationData",
			"allTags",
			"deliverableDetail",
			"allDepartments",
			"allSubjects",
			"userDeliverables",
			"unGroupedUserDeliverables",
			"deliverableFilter",
      		"myWeekDeliverableFilter",
			"outletCount",
			"userAbilities",
      		"userViews",
			"deliverableTypes",
			"userManageProjects",
			"deliverableCount",
			"systemSettings",
			"getSocialMediaOnlyCalendar",
			"getSocialMediaWithSocialCampaignAndSeries",
			"getSocialMediaWithSocialSeries",
			"getSocialMediaWithSocialCampaign",
			"getLangCodeById",
			"getSocialNetworkTypeById",
			"socialMediaFilter",
		]),
		...mapState({
			editSocialModal: state => state.deliverables.editSocialModal,
		}),

		getGroupHeading() {
			if (this.calendarOnly) {
				return this.getCalendarTitle;
			}
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
				return this.socialCampaignName + " => " + this.socialSeriesName;
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				return this.socialSeriesName;

			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				return this.socialCampaignName;

			}
		},
		getCalendarTitle() {
			const listDateRange = this.socialMediaFilter.filterByPublishDate ? this.socialMediaFilter.datePublishRange : this.socialMediaFilter.listDatePublishRange;
			const listByDate = this.socialMediaFilter.filterByPublishDate || this.socialMediaFilter.listByPublishDate;
			
			const startDate = this.$moment(listDateRange.startDate);
			const endDate = this.$moment(listDateRange.endDate);

			const calendarFormat = this.$moment().isSame(startDate, 'year') && this.$moment().isSame(endDate, 'year') ? 'MMMM DD' : 'MMMM DD, YYYY';
			const calendarFormatMonth = this.$moment().isSame(startDate, 'year') ? 'MMMM' : 'MMMM, YYYY';


			if (listDateRange && listByDate) {
				if (startDate.isSame(endDate, 'day')) {
					return `${startDate.format(calendarFormat)} Calendar`;
				}

				const isStartEndSameMonth = startDate.isSame(endDate, 'month');
				if (isStartEndSameMonth) {
					const startOfMonth = this.$moment(startDate).startOf("month");
					const endOfMonth = this.$moment(endDate).endOf("month");
					if (startOfMonth.isSame(startDate, 'day') && endOfMonth.isSame(endDate, 'day')) {
						return `${startOfMonth.format(calendarFormatMonth)} Calendar`;
					}
				}

				return `${this.$moment(listDateRange.startDate).format(calendarFormat)} to ${this.$moment(listDateRange.endDate).format(calendarFormat)}`;
			} else {
				return `${this.$moment().format("MMMM")} Calendar`;
			}
		},


		getGroupType() {
			if (this.calendarOnly) {
				return "Monthly Calendar";
			}
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
				return "Campaign Series";
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				return "Series";
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				return "Campaign";
			}
		},


		getSummaryFilterText() {
			if (typeof this.listCount != "undefined") {
				return  this.getGroupHeading +": <span>"+this.listCount +" of " + this.totalCount + " post(s)</span>";
			}
			return "";
		},

		getSummaryTotalText() {
			var text = "";
			var count = this.deliverablesArray.length;
			if (this.calendarOnly) {
				text =  "Monthly Calendar";
			}
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
				text =  "Series in Campaign";
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				text =  "Series";
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				text =  "Campaign";
			}
			return text+": <span>"+count+" post(s)</span>";f
		},


		deliverablesArray() {
			if (this.calendarOnly) {
				return this.getSocialMediaOnlyCalendar;
			}
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {

				return this.getSocialMediaWithSocialSeries(this.socialSeriesId);
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				return this.getSocialMediaWithSocialSeries(this.socialSeriesId);
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				return this.getSocialMediaWithSocialCampaign(this.socialCampaignId);
			}
			//return this.allDeliverables;
			return [];
		},


		_() {
			return _;
		},

		token(){
		  return this.$store.getters.authToken;
		},

   	apiUrl() {
  	  return process.env.MIX_API_BASE_URL;
  	},

		listedLanguages() {
			let langs = [];
			let that = this;
			if(this.systemSettings.languages){
				for(var j = 0; j < 2; j++){
					if (that.systemSettings.languages[j].lang_code == "en") {
						langs.push(that.systemSettings.languages[j]);
					}
				}
			}
			return langs;
		},

 	},
	methods: {
		...mapActions([
			"fetchSocialMediaDeliverablesGrouped",
			"updateFieldValue",
			"fetchDeliverableCount",
			"createNewDeliverable",
		]),
		...mapMutations([
			"setDataLoading",
		]),

		toggleExpanded() {
			this.expanded = !this.expanded;
			this.$emit('toggleExpanded');
		},

		getRowClass(deliverable, index) {
			let classes = "row listing-row";
			if (deliverable.is_master) {
				classes += " is-master";
			}

			// Check to see if we need to put the separator between
			if (index > 0) {
				const prevDeliverable = this.deliverablesArray[index - 1];
				const deliverable = this.deliverablesArray[index];
				if (deliverable.publish_date == null && prevDeliverable.publish_date != null) {
					classes += " is-separate-date";
				}
			}

			if(parseInt(deliverable.id) === parseInt(this.selectedDeliverable)){
				classes += " active";
			}

			return classes;
		},

		getLangColorClass(lang_id,deliverable) {
			if (deliverable) {
				var code = this.getLangCodeById(lang_id);
				var has_caption = false;
				if (deliverable.social_posts) {
					for (var x =0; x < deliverable.social_posts.length; x++) {

						if (deliverable.social_posts[x].lang_id == lang_id && deliverable.social_posts[x].caption != null && deliverable.social_posts[x].caption != "") {
							has_caption = true;
						}
						if (!has_caption) {
							// let's see if there is a re-tweet share url.
							if (deliverable.social_posts[x].share_urls) {
								if (deliverable.social_posts[x].share_urls.length > 0) {
									for (var xx =0; xx < deliverable.social_posts[x].share_urls.length; xx++) {
										if (deliverable.social_posts[x].share_urls[xx].url != "" &&
										deliverable.social_posts[x].share_urls[xx].url != null
										)  {
											has_caption = true;
										}
									}
								}
							}
						}
					}
				}
				if (has_caption) {
					return "has-content";
				} else {
					return "no-content"
				}
			}

		},

		setActiveView() {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(localStorage.getItem('dashboardActiveSave')) {
					this.activeView = localStorage.getItem('dashboardActiveSave');
					this.viewBtnLabel = localStorage.getItem('dashboardActiveSaveTitle');
					this.currentViewData = localStorage.getItem('dashboardActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(localStorage.getItem('myWeekActiveSave')) {
					this.activeView = localStorage.getItem('myWeekActiveSave');
					this.viewBtnLabel = localStorage.getItem('myWeekActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myWeekActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				if(localStorage.getItem('mediaCallActiveSave')) {
					this.activeView = localStorage.getItem('mediaCallActiveSave');
					this.viewBtnLabel = localStorage.getItem('mediaCallActiveSaveTitle');
					this.currentViewData = localStorage.getItem('mediaCallActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}

			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},

		resetView() {
			localStorage.removeItem("dashboardActiveSave");
			localStorage.removeItem("myWeekActiveSave");
			localStorage.removeItem("dashboardActiveSaveTitle");
			localStorage.removeItem("myWeekActiveSaveTitle");
			localStorage.removeItem("mediaCallActiveSave");
			localStorage.removeItem("mediaCallActiveSaveTitle");
			this.setActiveView();
		},

		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},

		getSeriesMasterByDeliverable(deliverable){
      let series = deliverable.social_series_deliverables;
      if(series.length){
        let master = series.find(x => x.is_master === 1);
        if(master){
          return master.id;
        }
      }
      return false;
    },

		getNewPostButtonText() {
			var btn = "New Calendar Post";
			if (this.socialSeriesId != null && this.socialCampaignId != null && this.hasSocialCampaign && this.hasSocialSeries) {
						btn = "New Campaign Series Post";
			}
			if (this.socialSeriesId != null && !this.hasSocialCampaign && this.hasSocialSeries) {
				btn = "New Series Post";
			}
			if (this.socialCampaignId != null && this.hasSocialCampaign && !this.hasSocialSeries) {
				btn = "New Campaign Post";
			}
			return btn;
		},

		showModalFn(deliverable) {
			/*
			if(deliverable.social_series.length && !deliverable.manually_updated_at){
				this.$emit("showEditDeliverableModal", this.getSeriesMasterByDeliverable(deliverable));
			} else {
				this.$emit("showEditDeliverableModal", deliverable.id);
			}
			*/
			this.$emit("showEditDeliverableModal", deliverable);
		},

		clickDeliverableTitle(deliverable){
			this.$emit("showEditDeliverableModal", deliverable, 0);
		},

		clickDeliverableComments(deliverable){
			this.$emit("showEditDeliverableModal", deliverable, 1);
		},

		clickDeliverableStatus(deliverable){
			this.$emit("showEditDeliverableModal", deliverable, 2);
		},
		
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') != -1) {
				this.$router.push({name: 'socialMedia'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},

		getPublishStatus(deliverable) {
			var html = "";
			if (deliverable.publish_status) {
			var status = JSON.parse(deliverable.publish_status);
			if (status.slug == "cancelled") {
				html += "<span class='publish-status-notes'>ICON</span>";
			}
			html += "<span class='publish-status "+status.slug + "' style='background-color:"+status.color+"'>"+status.name+"</span>";
			}
			return html;
		},

		getPublishStatusStyle(publish_status) {
			if (publish_status) {
				var status = JSON.parse(publish_status);
				return "background-color:"+status.color;
			}
			return "";
		},

		getFirstSocialPostThumbnail(deliverable) {
			var html = "";
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if (deliverable.social_posts[0].files) {
							if (deliverable.social_posts[0].files.length > 0) {
									html += "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+deliverable.social_posts[0].id+"/"+deliverable.social_posts[0].files[0].id+"/"+this.token+"'/>";
								/*
								for(var  x = 0; x < deliverable.social_posts[0].files.length; x++) {
									html += "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+deliverable.social_posts[0].id+"/"+deliverable.social_posts[0].files[x].id+"/"+this.token+"'/>";
								}
								*/
							}
						}
					}
				}
			}
			return html;
		},
		getFirstSocialPostCaption(deliverable, returnCount = false) {
			if (deliverable) {
				if (deliverable.social_posts) {
					if (deliverable.social_posts[0]) {
						if(deliverable.social_posts[0].caption){
							let caption = deliverable.social_posts[0].caption;
							if(returnCount){
								//return "("+caption.length+" characters)";
								return caption.length;
							}
							if(caption.length > this.captionMaxLength){
								caption = caption.substr(0, this.captionMaxLength);
								caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
							}
							return caption;
						}
					}
				}
			}
		},

		getImageForLang(deliverable, lang){
			let posts = deliverable.social_posts.filter(function(post){
				if(post.lang_id === lang.id && post.is_primary){
					return true;
				}
			});
			if(posts.length){
				let post = posts[0];
				let files = post.files;
				if(files.length){
					let file = files[0];
					return "<img src='"+this.apiUrl+"viewFileSocialMediaPost/"+post.id+"/"+file.id+"/"+this.token+"'/>";
				}
			}
			return "";
		},

		getCaptionForLang(deliverable, lang, returnCount = false){
			let posts = deliverable.social_posts.filter(function(post){
				if(post.lang_id === lang.id && post.is_primary){
					return true;
				}
			});
			if(posts.length){
				let caption = posts[0].caption;
				if(caption){
					if(returnCount){
						return caption.length;
					}
					if(caption.length > this.captionMaxLength){
						caption = caption.substr(0, this.captionMaxLength);
						caption = caption.substr(0, caption.lastIndexOf(" ")) + "...";
					}
					return caption;
				}
			}
			if(returnCount){
				return 0;
			}
			return "";
		},

		formatDate(theDate) {
			let html = "";

			if (theDate == null) {
				html = "<span class='not-set'>Not set</span>";
			} else {
				let localDate = this.$moment.utc(theDate).local();
				if (this.currentYear == localDate.format("YYYY")) {

					if (this.currentMonth == localDate.format("MM") && this.currentDay == localDate.format("DD")) {
							html = "Today " + localDate.format(" @ h:mm a");
					} else {
						html = localDate.format("ddd, MMM D @ h:mm a");
					}


				} else {
					html = this.$moment.utc(theDate).local().format("ddd, MMM D YYYY @ h:mm a");
				}
			}
			return html;
		},

		infoColStyle(deliverable) {
			// Unused for now
			if (deliverable.deliverable_template_id == 8) {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},

		userCanEditDeliverable() {
      return (this.userAbilities.deleteMediaCall);
    },

		deleteDeliverableClick(deliverable) {
			this.$emit('deleteSocialMediaDeliverable', deliverable);
			/*
			console.log(deliverable);
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.$bvModal.show("deleteDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteDeliverableConfirmModal");
				}
			}
			*/
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},
		onConfirmRemoveDeliverable() {
			if (this.showRemoveDeliverableId) {
				let that = this;
				let deliverable = null;
				if (this.deliverablesArray instanceof Array) {
					deliverable = this.deliverablesArray.find(x => x.id == this.showRemoveDeliverableId);
				} else {
					for (let i of Object.keys(this.deliverablesArray)) {
						deliverable = this.deliverablesArray[i].find(x => x.id == this.showRemoveDeliverableId);
						if (deliverable != null) break;
					}
				}
				let deliverableTemplateId = deliverable.deliverable_template_id;
				this.$store.dispatch("removeDeliverable", { deliverableId:this.showRemoveDeliverableId }).then(function() {
				that.$bvModal.hide("deleteDeliverableConfirmModal");
				// TODO: removing a deliverable should only remove it from the list, not replace entire list.
				// that.$store.commit('removeMediaCallFromList', deliverableId);
				// that.$store.dispatch('countOutlets');

				that.showRemoveDeliverableId = null;

				that.$store.dispatch('fetchSocialMediaDeliverablesGrouped').then(function() {
					toast.hide();

					if (deliverableTemplateId == 1) {
						that.$store.dispatch('manageUndoActivation', 'Media call deleted.');
					} else {
						that.$store.dispatch('manageUndoActivation', 'Deliverable deleted.');
					}

					that.$store.dispatch('fetchProjectDeliverable');
				});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		changeDeliverableType(deliverable, type) {
			if (deliverable.deliverable_template_id == type.typeId) return;
			this.$store.dispatch('changeDeliverableType', {
				id: deliverable.id,
				deliverable_type: type.id,
			}).then(r => {
				this.$store.dispatch('manageUndoActivation', 'Deliverable type changed.');
			});
		},
		canChangeDeliverableType() {
			if (this.$router.currentRoute.name == 'mediaCallPage' || this.deliverableTypes.length < 2) {
				return false;
			} else {
				return true;
			}
		},
		getDeliverableSideBarStyle(deliverable) {
			if (deliverable.publish_status) {
				const publishStatus = JSON.parse(deliverable.publish_status);
				return {backgroundColor: publishStatus.color};
			}
		},

		async clickGetAllGrouped() {
			this.$store.dispatch('fetchAllGroupedDeliverables', { social_campaign_id: this.socialCampaignId,social_series_id: this.socialSeriesId } ).then(function() {
				console.log("done");
				});
		},


		async newPost() {
		    const currentScroll = window.scrollY;
		    this.setDataLoading(true);
		    const type = {id: 'social_media', name: 'Social Media'};

		    await this.createNewDeliverable({ type: type.id, social_campaign_id: this.socialCampaignId, social_series_id : this.socialSeriesId });
		    if (type.id == 'social_media') {
		        if (this.groupTypeTitle == 'Campaign') {
		            await this.setDeliverableSocialCampaign({
		                id: this.deliverableDetail.id,
		                social_campaign_id: this.campaignId
		            });
		        } else if (this.groupTypeTitle == 'Series') {
		            await this.setDeliverableSocialSeries({
		                id: this.deliverableDetail.id,
		                social_series_id: this.seriesId
		            });
		        } else if (this.groupTypeTitle == 'Campaign Series') {
		        	await this.setDeliverableSocialCampaign({
		        	    id: this.deliverableDetail.id,
		        	    social_campaign_id: this.campaignId
		        	});
		            await this.setDeliverableSocialSeries({
		                id: this.deliverableDetail.id,
		                social_series_id: this.seriesId
		            });
		        }



		        this.setDataLoading(false);
		        this.$bvModal.show('editSocialModal');
		        await this.fetchSocialMediaDeliverablesGrouped();
		        window.scrollTo(0, currentScroll);
		    }
		},

		showManuallyUpdatedIcon(deliverable){
			if(deliverable.manually_updated_at){
				return true;
			}
			return false;
		},

	},
	mounted() {
		let that = this;
		this.$root.$on('bv::modal::hide', function(bvEvent, modalId) {
			if(modalId == 'editDeliverableModal' && that.$router.currentRoute.name == 'myWeek') {
				that.sortTasks({sortKey: false, deliverables: that.deliverablesArray, sortFields: true})
			}
		});
		this.$root.$on('updateListTitle', function(title) {
			that.listTitle = title;
		});
		this.setActiveView();

		this.currentYear = this.$moment().format("YYYY");
		this.currentMonth = this.$moment().format("MM");
		this.currentDay = this.$moment().format("DD");

		this.$root.$on('hideUpdateText', function() {
			that.showUpdateViewText = false;
		});
		this.$root.$on('resetView', function() {
			that.resetView();
		});
		let tempJson3 = false;
		this.$root.$on('showUpdateViewText', function(payload) {
			if(that.$router.currentRoute.name != 'myWeek' && that.$router.currentRoute.name != 'dashboard' && that.$router.currentRoute.name != 'mediaCallPage') return;

			let currentFilter = payload.currentFilter
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;

			if(!payload.isFilterActive) {
				that.activeView = '-1'
				that.viewBtnLabel = 'Views'
			}

			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if(typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if(tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if(typeof tempJson2[key] != 'undefined'
						&& excludedKeys.indexOf(key) == -1) {
						if(key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted'
							};
							if(tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
										that.activeView = -1;
									} else {
										that.showUpdateViewText = true;
									}
									return;
								}
							}
						} else {
							if(JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
									that.activeView = -1;
								} else {
									that.showUpdateViewText = true;
								}
								return;
							}
						}
					}
				});
			}
		});

		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
						this.$store.commit("setDeliverable", e.deliverable);
						this.$store.commit("setDeliverableDetail", e.deliverable);
					}
				}
			}
		});

		Echo.channel('task').listen('TaskUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {

					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								this.$store.commit("setTask", {task:e.task, deliverableId: e.deliverableId});
								}
						}
					}
				}
			}
		});

		this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editSocialModal") {
				this.$store.state.deliverables.editSocialModal = false;
				let currentTitle = document.title.match(/\(\d+\)\s/g);
        		if(!currentTitle) {
					document.title = process.env.MIX_APP_NAME;
				} else {
					document.title = currentTitle[0] + process.env.MIX_APP_NAME;
				}
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editSocialModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
		});

		/*
		if(this.$router.currentRoute.path.indexOf('/social-media-grouped/') != -1  ) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			this.$store.dispatch('fetchSystemSettings').then(function(){
				that.$store.dispatch('getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			});
		}
		*/
	},
	watch: {
		'$route': function(to, from) {
			if(to.path.indexOf('social-media/') != -1) {
				let deliverableId = to.path.split('/')[2],
					that = this;
				this.$store.dispatch('getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			}
		},
		'viewBtnLabel': function(oldVal, newVal) {
			console.log(oldVal);
		},
	}
};
</script>
